import {
  useEffect,
  useState,
} from 'react';

export const useMobile = () => {
  const MOBILE_WIDTH = 768;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_WIDTH);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= MOBILE_WIDTH);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return [isMobile];
};
